import React, { useContext } from 'react';
import { Skeleton } from '@material-ui/lab';
import Wheel from '@bit/kards.kards-components.wheel';
import { ThemeContext } from 'src/cards/edit/components/context/theme';

export default ({
  data: {
    title,
    description,
    titleModal,
  },
}) => {
  const {
    theme,
  }: any = useContext(ThemeContext);
  if (!title) {
    return (
      <div style={{ margin: '10px' }}>
        <Skeleton variant="circle" width="100%" height={250} />
      </div>
    );
  }
  return (
    <Wheel.component
      theme={theme}
      data={{ title, description, titleModal }}
    />
  );
};
